<template>
  <div>
    <el-drawer title="添加商品" :append-to-body="true" size="70%" direction="rtl" :visible.sync="innerDrawer" :destroy-on-close="true" @closed="$emit('closeInnerDrawer',false)">
      <div>
        <ul class="boxSize__ul" v-if="!!boxInfo">
          <li class="boxSize__li">
            <span class="label__span">箱子模板：</span>
            <!-- <el-select v-model="boxCode" placeholder="请选择" @change="selectBoxTemplate">
              <el-option v-for="item in boxTemplates" :key="item.deliveryBoxCode" :label="item.deliveryBoxId"
                :value="item.deliveryBoxCode">
              </el-option>
            </el-select> -->
            <span v-for="(item, index) in boxTemplateList" :key="index"
              v-if="item.boxTemplateId == boxSizeInfo.boxTemplateId">{{ item.templateName }}</span>
          </li>
          <li class="boxSize__li">
            <span class="label__span">长：</span>
            <el-input maxlength='450' v-model="boxSizeInfo.length" placeholder="箱子长">
              <template slot="append">cm</template>
            </el-input>
          </li>
          <li class="boxSize__li">
            <span class="label__span">宽：</span>
            <el-input maxlength='450' v-model="boxSizeInfo.width" placeholder="箱子宽">
              <template slot="append">cm</template>
            </el-input>
          </li>
          <li class="boxSize__li">
            <span class="label__span">高：</span>
            <el-input maxlength='450' v-model="boxSizeInfo.height" placeholder="箱子高">
              <template slot="append">cm</template>
            </el-input>
          </li>
          <li class="boxSize__li">
            <el-button type="primary" @click="editBoxSize">修改箱规</el-button>
          </li>
          <li class="boxSize__li">
            <span class="label__span">称重：</span>
            <!-- <el-input maxlength='450' v-model="boxInfo.weight" placeholder="箱子重" @change="setBoxWeight"> -->
            <el-input maxlength='450' v-model="boxInfo.weight" placeholder="箱子重">
              <template slot="append">g</template>
            </el-input>
          </li>
          <li class="boxSize__li">
            <el-button type="primary" @click="setBoxWeight(boxInfo.weight)">修改重量</el-button>
          </li>
        </ul>
        <div class="product__div--box" @click.self="activeScanIpt">
          <div @keyup.enter="scanCodeH">
            <el-input maxlength='450' placeholder="扫商品批次包" v-model="pkgCodeIpt" ref="productSanIpt"
              @keyup.enter="scanCodeH"></el-input>
          </div>
          <el-divider></el-divider>
          <el-table :data="doxDetailList.filter(item => item.nums !== 0)" v-if="!!boxInfo" :border="true">
            <el-table-column label="批次包编码" prop="pkgCode"></el-table-column>
            <el-table-column label="商品SKU" prop="shopProductSku"></el-table-column>
            <el-table-column label="商品名称" prop="productName"></el-table-column>
            <el-table-column label="FNSKU" prop="amazonFnsku" v-if="getdeliveryType() == 0"></el-table-column>
            <el-table-column label="ASIN" prop="amazonAsin" v-if="getdeliveryType() == 0"></el-table-column>
            <el-table-column label="商品图片" prop="productImg">
              <template slot-scope="scope">
                <ImgPreviews :images="[scope.row.productImg]"></ImgPreviews>
              </template>
            </el-table-column>
            <el-table-column label="本次数量" prop="nums">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.newNums" @change="(currentValue, oldValue)=>{ productNumChange(scope.row,currentValue, oldValue) }">
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="已装箱数量/总数量" prop="deliveryNums">
              <template slot-scope="scope">
                {{inNumsData[scope.row.pkgCode].inNums}}/{{inNumsData[scope.row.pkgCode].deliveryNums}}
              </template>
            </el-table-column>
            <el-table-column label="批次总数量" prop="pkgAmount">
              <template slot-scope="scope">
                {{ dataSource().filter(v => v.pkgCode == scope.row.pkgCode)[0].pkgAmount }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" prop="actions">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.newNums" @change="productNumChange(scope.row)">
                </el-input-number>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- <ul class="product__ul" v-if="!!boxInfo">
            <li class="product__li" v-for="product in doxDetailList"
              :class="{ 'product__li--active': product.isActive }" :key="product.shopProductSku">
              <span class="product__span">{{ product.shopProductSku }}</span>
              <el-input-number size="mini" v-model="product.newNums" @change="productNumChange(product)">
              </el-input-number>
            </li>
          </ul> -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { setContainerBoxInfo, setProductNums, setProductNumsWithPkg, getBox } from "@/apis/outStock";
import { audioPay } from "@/utils/tools";
import { Input } from "ant-design-vue";
import ImgPreviews from "@/components/ImgPreviews";

export default {
  name: "BoxView",
  inject: ['productSkuAll', 'reDetail', 'productSkuAll_shop', 'getdeliveryType', 'inNumsList', 'dataSource'],
  components: {
    ImgPreviews,
    [Input.name]: Input
  },
  data() {
    return {
      innerDrawer: false,
      insidePackCode: null, // 内部打包编号（容器编号）
      deliveryTaskCode: null, // 任务号
      boxInfo: null,
      boxSizeInfo: {
        width: 0,
        height: 0,
        length: 0
      },
      boxDisabled: false,
      boxCode: '',
      pkgCodeIpt: '',
      doxDetailList: [],
      boxTemplateList: [],
      inNumsData: {}
    }
  },
  props: {
    boxTemplates: {
      type: Array
    }
  },
  mounted() {
    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplateList = data
      }
    })
    let data = this.inNumsList()
    Object.keys(data).forEach(key => {
      data[key] = {
        deliveryNums: data[key].deliveryNums,
        newDeliveryNums: data[key].deliveryNums,
        inNums: data[key].inNums || 0,
        newInNums: data[key].inNums || 0
      }
    })
    console.log('mounted',this.inNumsList())
    this.inNumsData = data
  },
  methods: {
    open: function ({ boxInfo = null, insidePackCode, deliveryTaskCode }) {
      this.innerDrawer = true
      if (!!boxInfo) {
        const { width = 0, height = 0, length = 0, boxTemplateId } = boxInfo
        this.boxSizeInfo = {
          width,
          height,
          length,
          boxTemplateId
        }
      }
      this.boxCode = ''
      if (boxInfo.deliveryBoxCode) {
        this.boxCode = boxInfo.deliveryBoxCode
        this.boxDisabled = true
      }
      if (boxInfo.weight) {
        boxInfo.oldweight = boxInfo.weight
      }
      this.boxInfo = boxInfo
      this.doxDetailList = boxInfo.boxPkgDetailList.map(item => {
        return {
          ...item,
          newNums: item.nums,
          isActive: false
        }
      })
      this.insidePackCode = insidePackCode
      this.deliveryTaskCode = deliveryTaskCode
    },
    selectBoxTemplate: function (val) {
      const that = this
      // 当选中固定模板时
      if (!!val && val !== '') {
        that.boxDisabled = true
        that.boxTemplates.forEach(item => {
          if (item.deliveryBoxCode === val) {
            const { width, length, height } = item
            that.boxSizeInfo = {
              width,
              length,
              height,
            deliveryBoxDetailList: [...this.doxDetailList]
            }
          }
        })
      } else {
        // 自定义模板是解锁 input 禁用
        that.boxDisabled = false
      }
    },
    editBoxSize: function () {
      const that = this
      const { insidePackCode, deliveryTaskCode } = that
      const { width, height, length } = that.boxSizeInfo
      if (isNaN(width * 1) || isNaN(height * 1) || isNaN(length * 1)) {
        return this.$message.error('尺寸必须为数字！')
      }
      if(Number(width) > 99.9 || Number(height) > 99.9 || Number(length) > 99.9 ){ 
        this.$confirm(`请确认箱规是否正确,长：${length} 宽：${width} 高：${height}`, "提示", {
          confirmButtonText: "确认",
          type: "error",
          cancelButtonText: "取消",
        }).then(() => {
          nextStep()
        });
      }else{
        nextStep()
      }
      function nextStep(){
        const params = {
          deliveryTaskCode,
          insidePackCode,
          deliveryBoxId: that.boxInfo.deliveryBoxId,
          deliveryBoxCode: that.boxInfo.deliveryBoxCode,
          length,
          height,
          width
        }
        setContainerBoxInfo(params).then(res => {
          // console.log(res)
          const { code, data = [] } = res
          if (code === 0) {
            const _box = {
              ...that.boxInfo,
              length,
              height,
              width,
              deliveryBoxDetailList: [...that.doxDetailList],
              boxPkgDetailList: [...that.doxDetailList]
            }
            that.boxInfo = _box
            that.$emit('change', _box)
            that.$message.success('修改成功')
          }
        })
      }
    },
    setBoxWeight: function (val) {
      if (isNaN(val * 1)) {
        return this.$message.error('箱子重量必须为数字！')
      }
      const that = this
      const { insidePackCode, deliveryTaskCode } = that
      const { deliveryBoxCode, deliveryBoxId } = that.boxInfo
      const params = {
        deliveryBoxId,
        deliveryTaskCode,
        deliveryBoxCode,
        insidePackCode,
        weight: val
      }
      setContainerBoxInfo(params).then(res => {
        const { code, data = [] } = res
        if (code === 0) {
          const _box = {
            ...this.boxInfo,
            weight: val,
            deliveryBoxDetailList: [...this.doxDetailList],
            boxPkgDetailList: [...this.doxDetailList]
          }
          that.boxInfo = _box
          // that.boxInfo.oldweight = val
          this.$emit('change', _box)
          that.$message.success('修改成功')
        } else {
          that.boxInfo.weight = that.boxInfo.oldweight
        }
      })
    },
    // 扫码相关
    activeScanIpt: function () {
      this.$refs['productSanIpt'].focus()
    },
    scanCodeH: function () {
      const that = this
      const pkg = that.pkgCodeIpt
      const isNeed = this.productSkuAll().indexOf(pkg)
      if (isNeed < 0) {
        audioPay(`错误商品`)
        that.pkgCodeIpt = ''
      } else {
        const { deliveryBoxCode } = this.boxInfo
        // 原数量
        const nums = that.skuHandle(pkg)
        const targetSku = this.doxDetailList.filter(v=>v.pkgCode == pkg)[0]
        const params = {
          deliveryBoxCode,
          deliveryTaskCode: that.deliveryTaskCode,
          insidePackCode: that.insidePackCode,
          nums, // 扫描后加 1
          shopProductSku: this.getdeliveryType() == 0 ? targetSku.amazonFnsku : targetSku.shopProductSku,
          pkgCode: pkg
        }
        setProductNumsWithPkg(params).then(({ code, data }) => {
          if (code === 0) {
            //扫描成功
            // console.log(this.doxDetailList, 'this.doxDetailList2')
            that.rawDataHandle(true, data)
            // that.reDetail()
          } else {
            that.rawDataHandle(false)
            if(code == '26000019'){
              audioPay(`商品数量溢出`);
            }
          }
        }).catch(e => {
          that.rawDataHandle(false)
        }).finally(e => {
          that.pkgCodeIpt = ''
        })
      }
    },
    // 扫面成功专用数据改动函数
    skuHandle: function (sku) {
      const that = this
      let { boxInfo, doxDetailList, inNumsData } = that
      const _box = {
        ...boxInfo
      }
      let list = doxDetailList.map(item => {
        item.isActive = false
        return item
      })
      let useNums = 1 // 代表扫描后的 sku 数量
      let isHas = false
      list = list.map(item => {
        // if (this.productSkuAll_shop()[item.shopProductSku] && this.productSkuAll_shop()[item.shopProductSku].includes(sku)) {
        if (this.productSkuAll().includes(sku) && item.pkgCode == sku) {
          // 如果 sku 已存在执行加 1 逻辑，并标记 isHas
          useNums = item.newNums + 1
          item.newNums += 1
          item.isActive = true
          isHas = true
        }
        return item
      })
      console.log(list,useNums)
      if (!isHas) {
        // 如果 sku 不存在执行添加新 sku 逻辑
        const targetSku = this.dataSource().filter(v=>v.pkgCode == sku)[0]
        console.log(targetSku)
        list.push({
          shopProductSku: this.getdeliveryType() == 0 ? targetSku.amazonFnsku : targetSku.shopProductSku,
          pkgCode: sku,
          // shopProductSku: sku,
          isActive: true,
          newNums: 1,
          nums: 0
        })
      }

      // let shopSku = ''
      // let data = that.productSkuAll_shop()
      // Object.keys(data).forEach(key => {
      //   if (data[key].includes(sku)) {
      //     shopSku = key
      //   }
      // })
      inNumsData[sku].newInNums += 1
      console.log('list_______',list)
      that.doxDetailList = list
      that.inNumsData = inNumsData
      // console.log(this.doxDetailList, 'this.doxDetailList4')
      // 提供个请求参数使用
      return useNums
    },
    productNumChange: function (product,currentValue, oldValue) {
      console.log(currentValue, oldValue)
      const that = this
      const { inNumsData } = that
      const { deliveryBoxCode } = that.boxInfo
      const { newNums, shopProductSku, amazonFnsku, pkgCode } = product
      const outNum = inNumsData[pkgCode].inNums - oldValue

      inNumsData[pkgCode].newInNums = newNums + outNum
      const params = {
        deliveryBoxCode,
        deliveryTaskCode: that.deliveryTaskCode,
        insidePackCode: that.insidePackCode,
        nums: newNums,
        shopProductSku: this.getdeliveryType() == 0 ? amazonFnsku : shopProductSku,
        pkgCode: pkgCode
      }
      setProductNumsWithPkg(params).then(({ code, data }) => {
        if (code === 0) {
          that.rawDataHandle(true, data)
          // that.getDetails()
        } else {
          that.rawDataHandle(false)
          if(code == '26000019'){
            audioPay(`商品数量溢出`);
          }
        }
      }).catch(e => {
        that.rawDataHandle(false)
      })
    },
    // 原数据处理逻辑
    rawDataHandle: function (useNewVal, data = '') {
      const that = this
      let { boxInfo, doxDetailList, inNumsData } = that
      console.log(data,doxDetailList)
      const _box = {
        ...boxInfo
      }
      let activeItem = null
      let activeIndex = null
      if (useNewVal) {
        // 成功了把旧值更新为新值
        doxDetailList = doxDetailList.map((item, index) => {
          item.nums = item.newNums
          if (item.isActive) {
            item = {
              ...item,
              ...data,
              isActive: false
            }
            activeIndex = index
            activeItem = item
          }
          return item
        })
        Object.keys(inNumsData).forEach(key => {
          inNumsData[key].inNums = inNumsData[key].newInNums
        })
      } else {
        // 失败了把新值还原为旧值
        doxDetailList = doxDetailList.map((item, index) => {
          item.newNums = item.nums
          item.isActive = false
          return item
        })
        Object.keys(inNumsData).forEach(key => {
          inNumsData[key].newInNums = inNumsData[key].inNums
        })
      }
      //if activeitem把activeitem放到最前面
      if (activeItem) {
        doxDetailList.splice(activeIndex, 1)
        doxDetailList = [activeItem, ...doxDetailList]
      }
      that.doxDetailList = doxDetailList
      _box.boxPkgDetailList = that.doxDetailList;
      console.log('change',_box)
      this.$emit('change', _box)
    },
    del(scope) {
      console.log(scope)
    }
  }
}
</script>

<style scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px
}

.boxSize__ul {
  margin: 0 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.label__span {
  display: inline-block;
  padding-right: 20px;
}

.boxSize__li {
  margin: 8px 0;
  padding-left: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.boxSize__li ::v-deep.el-input {
  width: 140px;
}

.product__div--box {
  margin: 20px;
  border-radius: 12px;
  border: 1px solid #d2d2d2;
  min-height: 200px;
  box-shadow: 0 0 0px 10px rgba(0, 0, 0, 0.02);
  padding: 20px;
}

.product__ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  flex-wrap: wrap;
}

.product__li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  flex-direction: column;
  border-radius: 8px;
  margin: 10px;
  border: 1px solid #DCDFE6;
  background: #F5F7FA;
  position: relative;
  top: 0;
  left: 0;
}

.product__span {
  padding: 6px 30px 6px 10px;
}

.product__li::before {
  display: block;
  content: "";
  width: 12px;
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  height: 12px;
  position: absolute;
  top: 10px;
  right: 10px;
  background: #cccccc;
}

.product__li--active::before {
  background: #1bc318;
}
</style>